// extracted by mini-css-extract-plugin
export default {"intro":"Ge06a79","main":"G1c37a5","text":"G3e5dbc"};